export default __webpack_public_path__ + "static/media/16.2e807ffd.png";